import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED = createFcmDetails(
	'starter_dashboard_decision_makers_list_enabled',
	{
		owner: 'capybara',
		context: 'Starter Dashboard page',
		description: 'Feature release flag that enables the decision maker list on the starter dashboard',
		import: false,
		mergeLogic:
			'Checks `locale` and `countryCode` to determine value. Both must be `true` for the feature to be enabled',
	},
);
